import { useEffect, useState } from "react";

import { tw } from "@careinfo/tailwind";

import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

import {
  createAccount,
  createAccountInfovalidation,
} from "../../../validation/AccountInfo";
import Button from "../../Reusable/Button";
import AccountInfoForm from "../../AccountInfo/AccountForm";

const CreateAccountPopup = (props: any) => {
  const { handleCreateAccount, isLoading, setOpenAccountPopup } = props;
  const [isactive, setIsActive] = useState("credit");
  const {
    control,
    register,
    setValue,
    getValues,
    clearErrors,
    formState: { errors },
    handleSubmit,
    watch,
    setError,
  } = useForm<any>({
    resolver: yupResolver(createAccount),
  });
  useEffect(() => {
    setValue("balance_type", isactive);
  }, [isactive]);

  return (
    <form
      onSubmit={handleSubmit((data) =>
        handleCreateAccount(data, setOpenAccountPopup, setError)
      )}
      autoComplete="off"
    >
      <AccountInfoForm
        control={control}
        register={register}
        errors={errors}
        setValue={setValue}
        getValues={getValues}
        watch={watch}
        clearErrors={clearErrors}
        isactive={isactive}
        setIsActive={setIsActive}
      />
      <div className={tw`mt-4 w-full px-4 `}>
        <div className={tw`w-32 ml-auto`}>
          <Button label="Create" isLoading={isLoading} />
        </div>
      </div>
    </form>
  );
};

export default CreateAccountPopup;
